import { FaKey, FaLock, FaRegEnvelope } from "react-icons/fa";
import "./ForgotPass.scss";
import { useState } from "react";

export default function ForgotPass({
  setModalOpen,
  setEmailForForgot,
  emailForForgot,
}) {
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleForgotPass = async () => {
    const email = emailForForgot;
    if (!email.trim()) {
      alert("Email is required.");
      return;
    } else if (!validateEmail(emailForForgot)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/forgot-pass`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.error || "Login failed. Please try again.");
      } else {
        setModalOpen("OTP2"); // open modal
      }
    } catch (error) {
      console.error(error);
      alert("Network error. Please try again later.");
    }
  };

  return (
    <div className="forgotpass-container">
      <div className="icon-wrapper">
        <FaLock />
      </div>
      <h2>FORGOT PASSWORD</h2>

      <div className="enter-email-wrapper">
        <span>Enter your email:</span>
        <input
          type="email"
          value={emailForForgot}
          onChange={(e) => setEmailForForgot(e.target.value)}
        />
      </div>

      <button className="otp-button" onClick={handleForgotPass}>
        SEND OTP
      </button>
    </div>
  );
}
